module.exports = __webpack_public_path__ + "static/img/haus4.81f76d9b.webp";